export default ({ next, store }) => {
  store.dispatch('User/fetchUserAction')
  next()
}
